import { Injectable } from '@angular/core';
import { Model_ResponseWorkflow, STATUS_WORKFLOW, TYPE_DECLENCHEUR, TYPE_DEFAULT_VALUE, TYPE_ACTION_DATASOURCE_DECLENCHEUR, TYPE_DATASOURCE, FONCTION_WORKFLOW_COMPONENT, Model_Agent, Model_VariableEnvironnementUser, AbsPaginatedGrid, Model_Declencheur, StartupInfos_HistoriqueResponseWorkflows, QueryParams_ResponseWorkflow, PaginatedResults, CODE_WORKFLOW_COMPONENT, ACTION_LOG } from 'src/app/app.models';
import * as moment from 'moment';
import { ResponseWorkflowService } from './response-workflow.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';
import * as mathjs from 'mathjs'
import { Guid } from 'guid-typescript';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ResponseWorkflowOfflineService extends ResponseWorkflowService {
    constructor(
        protected _unitOfWork: UnitOfWorkOfflineDao,
        private _authService: AuthService
    ) {
        super(_unitOfWork);
    }

    doGetHistoriqueStartupInfosAction() {
        return new Promise<StartupInfos_HistoriqueResponseWorkflows>(async (resolve, reject) => {
            const startupInfos: StartupInfos_HistoriqueResponseWorkflows = {
                WORKFLOWS: await this._unitOfWork.workflowDao.doGetWorkflowsAction(),
                AGENTS: []
            };
            resolve(startupInfos)
        })
    }

    doGetResponsesWorkflowAction(_queryParams: QueryParams_ResponseWorkflow) {
        return new Promise<PaginatedResults<Model_ResponseWorkflow>>(async (resolve, reject) => {
            const responses = await this._unitOfWork.responseWorkflowDao.doGetResponsesAction();
            responses.forEach((response, index, resArray) => {
                resArray[index].AGENT = this._authService.AuthSession.User;
            })
            const paginatedResults: PaginatedResults<Model_ResponseWorkflow> = {
                mDatas: responses,
                mCountTotal: responses.length,
                mPageSize: responses.length,
                mPageNumber: 1,
                mTotalPages: 1
            };
            resolve(paginatedResults);
        })
    }

    doSaveResponseWorkflowAction(_responseWorkflow: Model_ResponseWorkflow) {
        return new Promise<Model_ResponseWorkflow>(async (resolve, reject) => {
            try {
                const authUser = this._authService.AuthSession.User;
                if (_responseWorkflow.USER_ID == authUser.ID) {
                    _responseWorkflow.AGENT = authUser;
                } else {
                    _responseWorkflow.AGENT = new Model_Agent();
                }
                const isInsertion = _responseWorkflow.ID === undefined && _responseWorkflow.GUID_SYNCHRONISATION === undefined;
                const response = await this._unitOfWork.responseWorkflowDao.doSaveResponsesAction(_responseWorkflow);
                if (response.STATUS_WORKFLOW == STATUS_WORKFLOW.ACHEVE) {
                    try {
                        await this._ProcessWorkflowDeclencheurs(response);
                    } catch(e) {
                        if (isInsertion) {
                            await this._unitOfWork.responseWorkflowDao.doDeleteResponseWorkflowAction(response.GUID_SYNCHRONISATION);
                        }
                        throw e;
                    }
                }
                resolve(response);
            } catch(e) {
                reject(e || 'Erreur lors de l\'enregistrement de l\'execution du workflow');
            }
        });
    }

    private async _ProcessWorkflowDeclencheurs(response: Model_ResponseWorkflow) {
        const responseComponentValues = response.RESPONSE_STEPS.map(s => s.FORM_RESPONSES).reduce((accum, formResponses) => { accum = Object.assign(accum, formResponses); return accum; }, {});
        const workflow = await this._unitOfWork.workflowDao.doGetWorkflowAction(response.NUM_WORKFLOW);
        const variables = this._authService.envVariables$.value;
        const agent = this._authService.AuthSession.User;

        for (var s in workflow.WORKFLOW_STEPS) {
            const step = workflow.WORKFLOW_STEPS[s];
            for (var d in step.DECLENCHEURS) {
                const declencheur = step.DECLENCHEURS[d];
                switch(declencheur.TYPE_DECLENCHEUR) {
                    case TYPE_DECLENCHEUR.ACTION_VARIABLE:
                        await this._ProcessActionVariableDeclencheur(declencheur, response, agent, variables, responseComponentValues);
                        break;

                    case TYPE_DECLENCHEUR.ACTION_DATASOURCE:
                        await this._ProcessActionDatasourceDeclencheur(declencheur, response, agent, variables, responseComponentValues);
                        break;
                }
            }
        }
    }

    private async _ProcessActionVariableDeclencheur(declencheur: Model_Declencheur, response: Model_ResponseWorkflow, agent: Model_Agent, variables: Model_VariableEnvironnementUser[], responseComponentValues: {[key: string]: any}) {
        const optionsActionVariable = declencheur.PARAMS_DECLENCHEUR.ACTION_VARIABLE_ENVIRONNEMENT_OPTIONS;
        const variableEnvironnement = await this._unitOfWork.envVarUserDao.doGetEnvironmentVariableUserAction(optionsActionVariable.NOM_VARIABLE);
        if (!!variableEnvironnement) {
            const logVar: any = {
                VARIABLE_ENVIRONNEMENT_ID: variableEnvironnement.VARIABLE_ENVIRONNEMENT_ID,
                VARIABLE_ENVIRONNEMENT_USER_ID: variableEnvironnement.ID,
                NOM_VARIABLE: variableEnvironnement.NOM_VARIABLE,
                DATE_LOG: moment().format(),
                ACTION_LOG: ACTION_LOG.MODIFICATION,
                BEFORE_VALUE: variableEnvironnement.VALEUR_VARIABLE,
                USER_ID: agent.ID,
                PARAMS_LOG: { RESPONSE_WORKFLOW_ID: response.ID, DECLENCHEUR_ID: declencheur.ID, NUM_WORKFLOW: declencheur.NUM_WORKFLOW, NUM_WORKFLOWSTEP: declencheur.NUM_WORKFLOWSTEP },
                VARIABLE_ENVIRONNEMENT_USER: variableEnvironnement,
                AGENT: agent,
                SYNCED: false
            }
            try {
                let newValue = variableEnvironnement.VALEUR_VARIABLE;
                if (optionsActionVariable.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.CONSTANT) {
                    newValue = optionsActionVariable.CONSTANT_VALUE_VARIABLE_ENVIRONNEMENT;
                } else if (optionsActionVariable.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
                    if (!!responseComponentValues[optionsActionVariable.WORKFLOW_COMPONENT_VARIABLE_ENVIRONNEMENT]) {
                        newValue = responseComponentValues[optionsActionVariable.WORKFLOW_COMPONENT_VARIABLE_ENVIRONNEMENT];
                    }
                } else if (optionsActionVariable.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.COMPUTED) {
                    let expression = optionsActionVariable.EXPRESSION_VARIABLE_ENVIRONNEMENT;

                    let regex = /\#\[([\w]+)\]/g;
                    let computedControls = expression.match(regex);
                    if (!!computedControls) {
                        computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((match) => {
                            const matchedVariable = variables.find(c => c.NOM_VARIABLE == match);
                            if (!!matchedVariable) {
                                var fieldValue = parseFloat(matchedVariable.VALEUR_VARIABLE);
                                if (isNaN(fieldValue)) {
                                    fieldValue = 0;
                                }
                                expression = expression.replace(new RegExp('\\#\\[' + match + '\\]', 'g'), fieldValue);
                            }
                        });
                    }

                    regex = /\@\[([\w]+)\]/g;
                    computedControls = expression.match(regex);
                    if (!!computedControls) {
                        computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((match) => {
                            if (!!responseComponentValues[match]) {
                                var fieldValue = parseFloat(responseComponentValues[match]);
                                if (isNaN(fieldValue)) {
                                    fieldValue = 0;
                                }
                                expression = expression.replace(new RegExp('\\@\\[' + match + '\\]', 'g'), fieldValue);
                            } else {
                                expression = expression.replace(new RegExp('\\@\\[' + match + '\\]', 'g'), 0);
                            }
                        });
                    }

                    try {
                        newValue = mathjs.evaluate(expression);
                    } catch(e) {}
                }
                variableEnvironnement.VALEUR_VARIABLE = newValue;
                variableEnvironnement.SYNCED = false;
                await this._unitOfWork.envVarUserDao.doSaveEnvironmentVariablesUserAction(variableEnvironnement);

                logVar.CURRENT_VALUE = newValue;
                await this._unitOfWork.logEnvVarUserOfflineDao.doSaveLogEnvVarUserAction(logVar);
            } catch(e) {
                logVar.RESULT_LOG = e.Message || `Erreur survenue lors de la modification de la variable @[${variableEnvironnement.NOM_VARIABLE}]`;
                await this._unitOfWork.logEnvVarUserOfflineDao.doSaveLogEnvVarUserAction(logVar);
            }
        }
    }

    private async _ProcessActionDatasourceDeclencheur(declencheur: Model_Declencheur, response: Model_ResponseWorkflow, agent: Model_Agent, variables: Model_VariableEnvironnementUser[], responseComponentValues: {[key: string]: any}) {
        const optionsActionDatasource = declencheur.PARAMS_DECLENCHEUR.ACTION_DATASOURCE_OPTIONS;
        const datasource = await this._unitOfWork.datasourcesDao.doGetDatasourceAction(optionsActionDatasource.NUM_DATASOURCE);

        if (datasource.TYPE_DATASOURCE == TYPE_DATASOURCE.STATIC) {
            const primaryKeyMapping = optionsActionDatasource.COLUMNS_MAPPING.find(c => c.PRIMARY_KEY === true);
            const buildedDatasource = await this._unitOfWork.datasourcesDao.doBuildDatasourceByNumAction(optionsActionDatasource.NUM_DATASOURCE);

            if (optionsActionDatasource.TYPE_ACTION_DATASOURCE == TYPE_ACTION_DATASOURCE_DECLENCHEUR.INSERT) {
                let rowProcessed = false;

                if (
                    !!optionsActionDatasource.UPDATE_DATAS_IF_EXISTS && optionsActionDatasource.UPDATE_DATAS_IF_EXISTS === true && 
                    !!primaryKeyMapping && 
                    !!responseComponentValues[primaryKeyMapping.DEFAULT_VALUE] &&
                    buildedDatasource.mColumns.findIndex(c => c == primaryKeyMapping.DATASOURCE_COLUMN) > -1
                ) {
                    const rowIndex = buildedDatasource.mPagination.mDatas.findIndex(row => !!row[primaryKeyMapping.DATASOURCE_COLUMN] && !!responseComponentValues[primaryKeyMapping.DEFAULT_VALUE] && row[primaryKeyMapping.DATASOURCE_COLUMN] == responseComponentValues[primaryKeyMapping.DEFAULT_VALUE]);
                    if (rowIndex > -1) {
                        for (var c in optionsActionDatasource.COLUMNS_MAPPING) {
                            const columnMapping = optionsActionDatasource.COLUMNS_MAPPING[c];
                            const columnValue = this._EvaluateDatasourceColumnValue(response, agent, variables, buildedDatasource, columnMapping, responseComponentValues);
                            buildedDatasource.mPagination.mDatas[rowIndex][columnMapping.DATASOURCE_COLUMN] = columnValue;
                        }
                        rowProcessed = true;
                    }
                }

                if (rowProcessed === false) {
                    const newRow: any = {};
                    for (var c in optionsActionDatasource.COLUMNS_MAPPING) {
                        const columnMapping = optionsActionDatasource.COLUMNS_MAPPING[c];
                        const columnValue = this._EvaluateDatasourceColumnValue(response, agent, variables, buildedDatasource, columnMapping, responseComponentValues);
                        newRow[columnMapping.DATASOURCE_COLUMN] = columnValue;
                    }
                    buildedDatasource.mPagination.mDatas.push(newRow);
                }
            } else if (optionsActionDatasource.TYPE_ACTION_DATASOURCE == TYPE_ACTION_DATASOURCE_DECLENCHEUR.UPDATE) {
                if (!!primaryKeyMapping && buildedDatasource.mColumns.findIndex(c => c == primaryKeyMapping.DATASOURCE_COLUMN) > -1) {
                    const rowIndex = buildedDatasource.mPagination.mDatas.findIndex(row => !!row[primaryKeyMapping.DATASOURCE_COLUMN] && !!responseComponentValues[primaryKeyMapping.DEFAULT_VALUE] && row[primaryKeyMapping.DATASOURCE_COLUMN] == responseComponentValues[primaryKeyMapping.DEFAULT_VALUE]);
                    if (rowIndex > -1) {
                        for (var c in optionsActionDatasource.COLUMNS_MAPPING) {
                            const columnMapping = optionsActionDatasource.COLUMNS_MAPPING[c];
                            const columnValue = this._EvaluateDatasourceColumnValue(response, agent, variables, buildedDatasource, columnMapping, responseComponentValues);
                            buildedDatasource.mPagination.mDatas[rowIndex][columnMapping.DATASOURCE_COLUMN] = columnValue;
                        }
                    }
                }
            } else if (optionsActionDatasource.TYPE_ACTION_DATASOURCE == TYPE_ACTION_DATASOURCE_DECLENCHEUR.DELETE) {
                if (!!primaryKeyMapping && buildedDatasource.mColumns.findIndex(c => c == primaryKeyMapping.DATASOURCE_COLUMN) > -1) {
                    const rowIndex = buildedDatasource.mPagination.mDatas.findIndex(row => !!row[primaryKeyMapping.DATASOURCE_COLUMN] && !!responseComponentValues[primaryKeyMapping.DEFAULT_VALUE] && row[primaryKeyMapping.DATASOURCE_COLUMN] == responseComponentValues[primaryKeyMapping.DEFAULT_VALUE]);
                    if (rowIndex > -1) {
                        buildedDatasource.mPagination.mDatas.splice(rowIndex, 1);
                    }
                }
            }

            datasource.datas = buildedDatasource;
            datasource.SYNCED = false;
            await this._unitOfWork.datasourcesDao.doSaveDatasourceAction(datasource);
        }
    }

    private _EvaluateDatasourceColumnValue(response: Model_ResponseWorkflow, agent: Model_Agent, variables: Model_VariableEnvironnementUser[], datatable: AbsPaginatedGrid<any>, columnMapping: any, responseComponentValues: {[key: string]: any}) {
        let columnValue = '';
        const defaultValue = columnMapping.DEFAULT_VALUE;
        const datasourceColumn = columnMapping.DATASOURCE_COLUMN;
        switch(columnMapping.TYPE_DEFAULT_VALUE)
        {
            case TYPE_DEFAULT_VALUE.CONSTANT:
                columnValue = defaultValue;
                break;

            case TYPE_DEFAULT_VALUE.WORKFLOW_FIELD:
                columnValue = responseComponentValues[defaultValue];
                break;

            case TYPE_DEFAULT_VALUE.ENVIRONMENT_VARIABLE:
                const env = variables.find(v => v.NOM_VARIABLE == defaultValue);
                if (!!env) {
                    columnValue = env.VALEUR_VARIABLE;
                }
                break;

            case TYPE_DEFAULT_VALUE.FONCTION:
                const fonctionId = defaultValue as FONCTION_WORKFLOW_COMPONENT;
                if (fonctionId == FONCTION_WORKFLOW_COMPONENT.ROW_INDEX) {
                    const maxIndex = datatable.mPagination.mDatas.reduce((accum, currentValue) => accum > parseInt(currentValue[datasourceColumn]) ? accum : parseInt(currentValue[datasourceColumn]) , 0);
                    columnValue = maxIndex + 1;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.GUID) {
                    columnValue = Guid.create().toString();
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.ID_AGENT) {
                    columnValue = agent.ID;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.NOM_AGENT) {
                    columnValue = agent.NOM;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.PRENOMS_AGENT) {
                    columnValue = agent.PRENOM;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.EMAIL_AGENT) {
                    columnValue = agent.EMAIL;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.USERNAME_AGENT) {
                    columnValue = agent.USERNAME;
                } else if (fonctionId == FONCTION_WORKFLOW_COMPONENT.DATE_EXECUTION_WORKFLOW) {
                    const dateDebutWorkflow = moment(response.DATE_DEBUT_WORKFLOW).format('DD/MM/YYYY HH:mm:ss');
                    columnValue = dateDebutWorkflow;
                }
                break;
        }

        return columnValue;
    }

    doGetResponseWorkflowByIDAction(ID: any) {
        return new Promise<Model_ResponseWorkflow>(async (resolve, reject) => {
            const response = await this._unitOfWork.responseWorkflowDao.doGetResponseAction(ID);
            response.WORKFLOW = await this._unitOfWork.workflowDao.doGetWorkflowAction(response.NUM_WORKFLOW);
            resolve(response);
        });
    }

    doCancelResponseWorkflow(ID: any) {
        return new Promise<Model_ResponseWorkflow>(async (resolve, reject) => {
            let response = await this._unitOfWork.responseWorkflowDao.doGetResponseAction(ID);
            response.STATUS_WORKFLOW = STATUS_WORKFLOW.ANNULE;
            response.DATE_FIN_WORKFLOW = moment().format();
            response = await this._unitOfWork.responseWorkflowDao.doSaveResponsesAction(response);
            resolve(response);
        });
    }

    async doGetNotSyncedResponsesWorkflow() {
        const localResponses = await this._unitOfWork.responseWorkflowDao.doGetResponsesAction();
        return localResponses.filter(r => r.SYNCED !== undefined && r.SYNCED === false);
    }

    doReadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string) {
        return new Promise<string>((resolve, reject) => {
            resolve(filename);
        });
    }

    doDownloadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string) {
        return new Promise<void>((resolve, reject) => {
            resolve();
        });
    }
}